module.exports = __webpack_public_path__ + "media/src/images/logo/logo-2-44788dbdcb0f55b46daca79c9ce5177d.png";